import global from 'globalMU'
import { ControllerBase } from 'controllerBase';
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice";
import store from "app/redux/store/store";
import {EditarParcelaController} from './editarParcelaController'
import {EditarParcelaContratoController} from './editarParcelaContratoController'
import {SimularFinanciamentoController} from './simularFinanciamentoController'
import * as R from 'ramda'

declare var window:any
declare var planoPagamentoEditadoCallback:any

const ko = require('knockout')

const PlanoPagamentoController = ControllerBase.extend({
    name: "PlanoPagamentoController",
    framework: "knockout",

    ajax: function() {

        return {
            url: "/Orcamento/_PlanoPagamento",
            type: "post",
            cache: false,
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento")
            }
        };
    },

    formConfig: {
        selector: "#form-plano-pagamento",
        rules: {
            'PlanoPagamento': {
                required: true
            },
            'Parcela': {
                required: true
            },
            'Carencia': {
                required: true
            },
            'DocumentoEntrada': {
                required: true
            }
        },
        messages: {
            'PlanoPagamento': {
                required: 'O campo "Plano de Pagamento" é obrigatório.'
            },
            'Parcela': {
                required: 'O campo "Parcelas" é obrigatório.'
            },
            'Carencia': {
                required: 'O campo "Carência" é obrigatório.'
            },
            'DocumentoEntrada': {
                required: 'O campo "Documento Entrada" é obrigatório.'
            }
        }

    },

    renderizado: function() {
        this.orcamento.on("change:CodigoFormaPagamento", this.formaPagamentoAlterada, this);

        $("input").on('focus', function () { $(this).select(); });
        $("#PlanoPagamento_PlanoDePagamento").focus();
    },

    dispose: function() {
        this.orcamento.off(null, this.formaPagamentoAlterada, this);
    },

    antesRenderizacaoCompleta: function() {

        this.addActionButton({
                text: "Limpar",
                'class': "icone-excluir separador",
                click: $.proxy(function() {

                        if (typeof this
                            .currentRegion ==
                            "undefined" ||
                            typeof this.currentRegion.options == "undefined") {
                            return;
                        }

                        this.limpar();

                    },
                    this)
            },
            true);

    },

    antesBinding: function() {

        this.appendToModel({ name: "CodigoPlanoPagamentoAnterior" });
        this.appendToModel({ name: "CodigoParcelaAnterior" });
        this.appendToModel({ name: "ExecutarSubscribers", value: true });
        this.appendToModel({ name: "AtualizarParcelaRemoto", value: true });
        this.appendToModel({ name: "AtualizarCarenciaRemoto", value: true });
        this.appendToModel({ name: "AtualizarRemoto", value: true });
        this.appendToModel({ name: "LimparParcelas", value: true });
        this.appendToModel({ name: "AtualizarValorEntrada", value: true });
        this.appendToModel({ name: "AtualizarDocumentoEntrada", value: true });
        this.appendToModel({ name: "habilitar", value: $.proxy(this.habilitar, this) });
        this.appendToModel({
            name: "novo",
            value: !this.model.CodigoPlanoPagamento || !this.model.CodigoPlanoPagamento()
        });
    },

    executarSubscriber: function(callback, alwaysExecuteCallback, value) {

        if (alwaysExecuteCallback && $.isFunction(alwaysExecuteCallback)) {
            alwaysExecuteCallback();
        }

        if (!this.model.ExecutarSubscribers()) return;

        if (callback) {
            callback();
        }

        if (this.model && this.model.LimparParcelas()) {
            if (this.model.Contrato && this.model.Contrato()) {
                this.model.Contrato(undefined);
            }
            if (this.model.Entrada && this.model.Entrada()) {
                this.model.Entrada(undefined);
            }
        }

    },

    aposBinding: function() {
        // FNX-570
        this.model.CodigoPlanoPagamentoAnterior(this.model.CodigoPlanoPagamento());

        this.model.CodigoPlanoPagamento.subscribe($.proxy(this.executarSubscriber,
            this,
            $.proxy(this.definirPlanoPagamento, this),
            $.proxy(this.codigoPlanoPagamentoAlterado, this)));
        this.model.CodigoParcela.subscribe($.proxy(this.executarSubscriber,
            this,
            $.proxy(this.definirParcela, this),
            $.proxy(this.codigoParcelaAlterado, this)));
        this.model.CodigoCarencia.subscribe($.proxy(this.executarSubscriber,
            this,
            $.proxy(this.definirCarencia, this),
            null));
        this.model.CodigoDocumentoPlanoPagamento.subscribe($.proxy(this.executarSubscriber, this, null, null));
        this.model.ComEntrada.subscribe($.proxy(this
            .executarSubscriber,
            this,
            $.proxy(this.definirEntrada, this),
            null));
        this.model.CodigoDocumentoEntrada.subscribe($.proxy(this.executarSubscriber, this, null, null));
        this.model.ValorEntrada.subscribe($.proxy(this.executarSubscriber, this, null, null));

        $("input").on('focus', function () { $(this).select(); });
    },

    habilitar: function() {
        if (this.readOnly) {
            return false;
        } else if ((this.model.SomenteLeitura && this.model.SomenteLeitura()) || (this.model.CodigoDAV && this.model.CodigoDAV() != "")) { // FNX-968
            return false;
        } else if (!this.model.novo() && this.model.permitidoAlterar()) {
            return true;
        } else if (this.model.novo() && this.model.permitidoIncluir()) {
            return true;
        }

        return false;

    },

    listarParcelas: function(codigoPlanoPagamento, callback, limparParcelas) {

        if (!codigoPlanoPagamento) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/ListarParcelasPlanoPagamento",
            type: "post",
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                codigoPlanoPagamento: codigoPlanoPagamento
            },
            success: function(data) {

                self.model.AtualizarParcelaRemoto(false);

                self.model.ParcelasPlanoPagamento(data);

                if (self.orcamento.get("CodigoParcelaPlanoPagamento")) {
                    self.model.LimparParcelas(limparParcelas == null || limparParcelas == undefined || limparParcelas);
                    self.model.CodigoParcela(self.orcamento.get("CodigoParcelaPlanoPagamento"));
                    self.model.LimparParcelas(true);
                }

                self.model.AtualizarParcelaRemoto(true);

                if (callback) {
                    callback();
                }

            }
        });

    },

    listarCarencias: function(codigoParcela, limparParcelas) {

        if (!codigoParcela) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/ListarCarenciasParcelaPlanoPagamento",
            type: "post",
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                codigoParcela: codigoParcela
            },
            success: function(data) {

                self.model.AtualizarCarenciaRemoto(false);

                self.model.Carencias(data);

                if (self.orcamento.get("CodigoCarenciaPlanoPagamento")) {
                    self.model.LimparParcelas(limparParcelas == null || limparParcelas == undefined || limparParcelas);
                    self.model.CodigoCarencia(self.orcamento.get("CodigoCarenciaPlanoPagamento"));
                    self.model.LimparParcelas(true);
                }

                self.model.AtualizarCarenciaRemoto(true);

            }
        });

    },

    removerPlanoPagamento: function() {

        var self = this;

        global.ajax({
            url: "/Orcamento/RemoverPlanoPagamento",
            type: "post",
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento")
            },
            success: function(data) {

                if (!data) {
                    return;
                }

                self.atualizar();
            }
        });

    },

    codigoPlanoPagamentoAlterado: function() {

        if (this.model.CodigoPlanoPagamento &&
            this.model.CodigoPlanoPagamento() &&
            this.model.CodigoPlanoPagamento() != this.model.CodigoPlanoPagamentoAnterior()) {
            this.model.CodigoPlanoPagamentoAnterior(this.model.CodigoPlanoPagamento());
            this.listarParcelas(this.model.CodigoPlanoPagamento());
            this.model.Carencias(undefined);
            this.model.NomeDocumentoPlanoPagamento(undefined);
        }
        if (this.model.CodigoPlanoPagamento &&
            this.model.CodigoPlanoPagamento() &&
            this.model.CodigoPlanoPagamento() <= 7)
        {
            this.listarParcelas(0);
            this.listarCarencias(0);
        }

    },

    definirPlanoPagamento: function() {


        if (!this.model.CodigoPlanoPagamento || !this.model.CodigoPlanoPagamento()) {
            this.removerPlanoPagamento();
            return;
        }

        var self = this;


        global.ajax({
            url: "/Orcamento/DefinirPlanoPagamento",
            type: "post",
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                codigoPlanoPagamento: this.model.CodigoPlanoPagamento()
            },
            success: function(data) {

                if (!data) {
                    return;
                }

                self.model.NomeDocumentoPlanoPagamento(data.NomeDocumentoPlanoPagamento);

                self.orcamento.set("CodigoPlanoPagamento", data.CodigoPlanoPagamento);
                store.dispatch(sobrescreverInformacoesAction({CodigoPlanoPagamento: data.CodigoPlanoPagamento}))
            }
        });

    },

    definirParcela: function() {

        if (!this.model.AtualizarParcelaRemoto()) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirParcelaPlanoPagamento",
            type: "post",
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                codigoParcela: this.model.CodigoParcela()
            },
            success: function(data) {

                if (!data) {
                    return;
                }

                //self.atualizar(data);


            }
        });

    },

    codigoParcelaAlterado: function() {

        if (this.model.CodigoParcela &&
            this.model.CodigoParcela() &&
            this.model.CodigoParcela() != this.model.CodigoParcelaAnterior()) {
            this.model.CodigoParcelaAnterior(this.model.CodigoParcela());
            this.listarCarencias(this.model.CodigoParcela());
        }

    },

    definirCarencia: function() {

        if (!this.model.AtualizarCarenciaRemoto()) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirCarenciaPlanoPagamento",
            type: "post",
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                codigoCarencia: this.model.CodigoCarencia()
            },
            success: function(data) {

                if (!data) {
                    return;
                }

                //self.atualizar(data);

            }
        });

    },

    nomeDocumentoPlanoPagamentoAlterado: function() {
        this.model.CodigoDocumentoPlanoPagamento(this.orcamento.get("CodigoDocumentoPlanoPagamento"));
        this.model.NomeDocumentoPlanoPagamento(this.orcamento.get("NomeDocumentoPlanoPagamento"));
    },

    codigoParcelaPlanoPagamentoAlterado: function() {
        this.model.CodigoParcela(this.orcamento.get("CodigoParcelaPlanoPagamento"));
    },

    definirComEntrada: function() {
        this.orcamento.set("PlanoPagamentoComEntrada", this.model.ComEntrada());
        store.dispatch(sobrescreverInformacoesAction({PlanoPagamentoComEntrada: this.model.ComEntrada()}))
    },

    listarDocumentosEntrada: function(limparParcelas) {

        if (!this.model.ComEntrada || !this.model.ComEntrada()) {
            return;
        }

        var self = this;
       
        global.ajax({
            url: "/Orcamento/ListarTiposDocumentoEntrada",
            type: "post",
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                //oidPlanoPagamento: this.model.CodigoPlanoPagamento()
            },
            success: function(data) {
               
                if (!data) {
                    global.showErrorMessage("Não foi encontrado nenhum documento de entrada relacionado a forma de pagamento!"); // MANUT-236
                    self.model.ComEntrada(false);
                    return;
                }

                self.model.TiposDocumentoEntrada(data);

                if (self.orcamento.get("CodigoDocumentoEntrada")) {
                    self.model.LimparParcelas(limparParcelas == null || limparParcelas == undefined || limparParcelas);
                    self.model.CodigoDocumentoEntrada(self.orcamento.get("CodigoDocumentoEntrada"));
                    self.model.LimparParcelas(true);

                }

            }
        });

    },

    atualizar: function(data, atualizarContrato) {

        if (!data || this.model.novo()) {
            return;
        }

        this.model.ExecutarSubscribers(false);
        this.model.LimparParcelas(false);


        this.model.CodigoPlanoPagamento(data.CodigoPlanoPagamento);

        this.model.CodigoParcela(data.CodigoParcela);
        this.model.CodigoCarencia(data.CodigoCarencia ? data.CodigoCarencia : undefined);
        this.model.CodigoDocumentoPlanoPagamento(data.CodigoDocumentoPlanoPagamento);
        this.model.NomeDocumentoPlanoPagamento(data.NomeDocumentoPlanoPagamento);
        this.model.ComEntrada(data.ComEntrada);
        this.model.CodigoDocumentoEntrada(data.CodigoDocumentoEntrada);
        this.model.ValorEntrada(global.formatNumber(data.ValorEntrada));

        if (atualizarContrato) {
            this.model.Entrada(ko.mapping.fromJS(data.Entrada));
            this.model.Contrato(ko.mapping.fromJS(data.Contrato));
        }
        
        store.dispatch(sobrescreverInformacoesAction(R.pick([
            "UtilizaPlanoPagamento",
            "CodigoPlanoPagamento",
            "CodigoDocumentoPlanoPagamento",
            "NomeDocumentoPlanoPagamento",
            "CodigoDocumentoEntrada",
            "NomeDocumentoEntrada",
            "ValorEntrada"
        ],data)))

        this.orcamento.set("UtilizaPlanoPagamento", data.UtilizaPlanoPagamento);
        this.orcamento.set("CodigoPlanoPagamento", data.CodigoPlanoPagamento);
        this.orcamento.set("CodigoParcelaPlanoPagamento", data.CodigoParcela);
        store.dispatch(sobrescreverInformacoesAction({CodigoParcelaPlanoPagamento: data.CodigoParcela}))
        this.orcamento.set("CodigoCarenciaPlanoPagamento", data.CodigoCarencia);
        store.dispatch(sobrescreverInformacoesAction({CodigoCarenciaPlanoPagamento: data.CodigoCarencia}))
        this.orcamento.set("CodigoDocumentoPlanoPagamento", data.CodigoDocumentoPlanoPagamento);
        this.orcamento.set("NomeDocumentoPlanoPagamento", data.NomeDocumentoPlanoPagamento);
        this.orcamento.set("PlanoPagamentoComEntrada", data.ComEntrada);
        store.dispatch(sobrescreverInformacoesAction({PlanoPagamentoComEntrada: data.ComEntrada}))
        this.orcamento.set("CodigoDocumentoEntrada", data.CodigoDocumentoEntrada);
        this.orcamento.set("NomeDocumentoEntrada", data.NomeDocumentoPlanoPagamento);
        store.dispatch(sobrescreverInformacoesAction({NomeDocumentoEntrada: data.NomeDocumentoPlanoPagamento}))
        this.orcamento.set("ValorEntrada", data.ValorEntrada);


        this.model.ExecutarSubscribers(true);
        this.model.LimparParcelas(true);


    },

    definirEntrada: function() {
        if (this.model.ComEntrada()) {
            this.listarDocumentosEntrada();
        } else {
            this.model.TiposDocumentoEntrada(undefined);
        }
    },

    definirDocumentoEntrada: function() {


        if (!this.model.AtualizarDocumentoEntrada()) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirDocumentoEntrada",
            type: "post",
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                codigoDocumentoEntrada: this.model.CodigoDocumentoEntrada()
            },
            success: function(data) {

                if (!data) {
                    return;
                }

                self.atualizar(data);

                self.model.AtualizarDocumentoEntrada(true);
            },
            error: function() {
                self.model.AtualizarDocumentoEntrada(true);
            }
        });


    },

    definirValorEntrada: function() {

        if (!this.model.AtualizarRemoto()) {
            return;
        }

        if (!this.model.AtualizarValorEntrada()) {
            return;
        }

        this.model.AtualizarValorEntrada(false);


        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirValorEntradaPlanoPagamento",
            type: "post",
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                valorEntrada: this.model.ValorEntrada ? this.model.ValorEntrada() : 0
            },
            success: function(data) {

                if (!data) {
                    return;
                }

                self.atualizar(data);

                self.model.AtualizarValorEntrada(true);
            },
            error: function() {
                self.model.AtualizarValorEntrada(true);
            }
        });

    },

    simularFinanciamento: function() {
        var self = this;
        this.showView({
            region: {
                name: "simularFinanciamentoRegion",
                selector: "#simular-financiamento-region"
            },
            controller: {
                type: SimularFinanciamentoController
            }
        });
    },

    salvar: function(model, e) {


        if (!global.isFormValid("#form-plano-pagamento", false)) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/GerarParcelasPlanoPagamento",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString(this.toJS(this.model)),
            success: function(data) {

                if (!data || data.HasErrors) {
                    return;
                }

                self.model.novo(false);
                self.atualizar(data, true);

                global.showSuccessMessage("Parcelas geradas com sucesso.");

            }
        });


        

    },

    formaPagamentoAlterada: function() {

        if (!this.orcamento.get("CodigoFormaPagamento")) {
            return;
        }

        this.limpar();

    },

    limpar: function () {
        this.model.AtualizarParcelaRemoto(false);
        this.model.AtualizarCarenciaRemoto(false);
        this.orcamento.unset("CodigoPlanoPagamento");
        this.orcamento.unset("CodigoParcelaPlanoPagamento");
        this.orcamento.unset("CodigoCarenciaPlanoPagamento");

        this.orcamento.unset("UtilizaPlanoPagamento");
        this.orcamento.unset("CodigoDocumentoPlanoPagamento");
        store.dispatch(sobrescreverInformacoesAction({CodigoDocumentoPlanoPagamento: undefined}))
        this.orcamento.unset("NomeDocumentoPlanoPagamento");
        store.dispatch(sobrescreverInformacoesAction({NomeDocumentoPlanoPagamento: undefined}))
        this.orcamento.unset("PlanoPagamentoComEntrada");
        this.orcamento.unset("CodigoDocumentoEntrada");
        this.orcamento.unset("NomeDocumentoEntrada");
        store.dispatch(sobrescreverInformacoesAction({NomeDocumentoEntrada: undefined}))
        this.orcamento.unset("ValorEntrada");

        this.model.CodigoPlanoPagamento(undefined);
        this.model.CodigoParcela(undefined);
        this.model.CodigoCarencia(undefined);
        this.model.NomeDocumentoPlanoPagamento(undefined);
        this.model.ComEntrada(false);
        this.model.CodigoDocumentoEntrada(undefined);
        this.model.ValorEntrada(undefined);

        this.model.CodigoDocumentoPlanoPagamento(undefined);
        this.model.Entrada(false);
        this.model.CodigoParcelaAnterior(undefined);
        this.model.LimparParcelas(undefined);
        this.model.AtualizarValorEntrada(undefined);
        this.model.AtualizarDocumentoEntrada(undefined);

        this.model.Entrada(undefined);
        this.model.Contrato(undefined);
        this.model.AtualizarParcelaRemoto(true);
        this.model.AtualizarCarenciaRemoto(true);
    },

    editarParcelaContrato: function(parcela) {
        var model = this.toJS(parcela);
        this.editarParcelaContratoController = this.showView({
            region: {
                name: "editarParcelaContratoRegion",
                selector: "#editar-parcela-contrato-region"
            },
            model: model,
            controller: {
                type: EditarParcelaContratoController,
                args: {
                    identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                    finalizarEdicaoCallback: $.proxy(this.finalizarEdicaoContrato, this),
                    readOnly: this.orcamento.get("SomenteLeitura") || this.orcamento.get("CodigoDAV") != "" // FNX-968
                }
            }
        });
    },

    finalizarEdicaoContrato: function(data) {
        var m = ko.mapping.fromJS(data.ParcelasFinanciamento);

        this.model.Contrato().ParcelasFinanciamento(m);

        this.editarParcelaContratoController.hide();
        this.show();
    },

    editarParcelaEntrada: function() {
        var model = this.toJS(this.model.Entrada);
        model.editandoEntradaPlano = true;
        this.editarParcelaEntradaController = this.showView({
            region: {
                name: "editarParcelaRegion",
                selector: "#editar-parcela-entrada-region"
            },
            model: model,
            controller: {
                type: EditarParcelaController,
                args: {
                    orcamento: this.orcamento,
                    finalizarEdicaoCallback: $.proxy(this.finalizarEdicaoEntrada, this),
                    readOnly: this.orcamento.get("SomenteLeitura") || this.orcamento.get("CodigoDAV") != "" // FNX-968
                }
            }
        });

    },

    finalizarEdicaoEntrada: function (data) {
        if (!data || data.HasErrors) {
            return;
        }
        var m = ko.mapping.fromJS(data.ParcelasFormaPagamento[0]);

        this.model.Entrada(m);

        this.editarParcelaEntradaController.hide();
        this.show();
    }

});

window.PlanoPagamentoController = PlanoPagamentoController

export {
    PlanoPagamentoController
}
